// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"94":"371b1b06","632":"0c4c744a","929":"c8ddcbe4"}[chunkId] + ".js";
};